/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
export default resolveComponentProps;


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/resolveComponentProps/resolveComponentProps.js
// module id = 1759
// module chunks = 25